/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState, useImperativeHandle } from "react";

/*============================================================
  MATERIAL UI
============================================================*/
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

/*============================================================
  PROPRIETARY - COMPONENTS
============================================================*/
import GridDropdown from "../../../widgets/GridDropdown";
import GridTextfield from "../../../widgets/GridTextfield";
import GridCheckbox from "../../../widgets/GridCheckbox";

/*============================================================
  PROPRIETARY - UTILS
============================================================*/
import { reNumbers } from "../../../../utils/fieldValidator.js";
import { validateCurrencyField3 } from "../../../../utils/fieldValidator.js";

const policyIllustrationdata = [
  { key: "Additional Cover", value: "Additional Cover" },
  { key: "Booster", value: "Booster" },
  { key: "Guaranteed Benefit", value: "Guaranteed Benefit" },
  { key: "Guaranteed Death Benefit", value: "Guaranteed Death Benefit" },
  { key: "Life Benefit Multiplier", value: "Life Benefit Multiplier" },
  { key: "Minimum Protection Amount", value: "Minimum Protection Amount" },
  { key: "Minimum Protection Cover", value: "Minimum Protection Cover" },
  { key: "Minimum Protection Value", value: "Minimum Protection Value" },
  { key: "Additional Sum Insured", value: "Additional Sum Insured" },
];

const typeData = [
  { key: "$", value: "$" },
  { key: "%", value: "%" },
];

export default function Multiplier({ title, productRecommendation, childRef }) {
  //PRODUCT MULTIPLIER
  const [addProductMultiplier, setAddProductMultiplier] = useState(false);
  const [policyIllustration, setPolicyIllustration] = useState("");
  const [prodMultiplierSumAssuredType, setProdMultiplierSumAssuredType] = useState("");
  const [prodMultiplierSumAssured, setProdMultiplierSumAssured] = useState("");
  const [prodMultiplierPremium, setProdMultiplierPremium] = useState("");
  const [prodMultiplierPremiumTerm, setProdMultiplierPremiumTerm] = useState("");
  const [prodMultiplierPremiumTermError, setProdMultiplierPremiumTermError] = useState("");
  const [prodMultiplierPolicyTerm, setProdMultiplierPolicyTerm] = useState("");
  const [prodMultiplierPolicyTermError, setProdMultiplierPolicyTermError] = useState("");

  //REFERENCE USED BY PARENT COMPONENT TO CALL THIS CHILD'S FUNCTION
  childRef.current = {
    clearScreen: clearScreen,
    validate: validate,
  };

  function handleChange(e, object) {
    let id = "";

    if (e instanceof PointerEvent) {
      id = object.props.id;

      if (id === "policyIllustration") {
        productRecommendation.policyIllustration = e.target.value;
        setPolicyIllustration(e.target.value);
        //actionType = "UPDATE_PROPOSER";
      }

      if (id === "prodMultiplierSumAssuredType") {
        productRecommendation.prodMultiplierBenefitType = e.target.value;
        setProdMultiplierSumAssuredType(e.target.value);
      }
    } else {
      id = e.target.id;

      let input_data = {
        event: e,
        fieldName: "",
        fieldVariable: "",
        isMandatory: false,
      };

      if (id === "addProductMultiplier") {
        productRecommendation.addProductMultiplier = e.target.checked;
        setAddProductMultiplier(e.target.checked);
      }

      if (id === "prodMultiplierSumAssured") {
        input_data.fieldName = "Sum assured";
        input_data.fieldVariable = prodMultiplierSumAssured;
        const result = validateCurrencyField3(input_data);
        if (result.errorMessage === "") {
          setProdMultiplierSumAssured(result.value);
          productRecommendation.prodMultiplierSumAssured = result.value;
          //actionType = "UPDATE_RIDER_SUM_ASSURED";
        }
      }

      if (id === "prodMultiplierPremium") {
        input_data.fieldName = "Multiplier premium";
        input_data.fieldVariable = prodMultiplierPremium;
        const result = validateCurrencyField3(input_data);
        if (result.errorMessage === "") {
          setProdMultiplierPremium(result.value);
          productRecommendation.prodMultiplierPremium = result.value;
          //actionType = "UPDATE_RIDER_SUM_ASSURED";
        }
      }

      if (id === "prodMultiplierPremiumTerm" && reNumbers.test(e.target.value)) {
        if (e.target.value.length === 0) {
          setProdMultiplierPremiumTermError("Premium term is required.");
        } else if (e.target.value.length > 3) {
          setProdMultiplierPremiumTermError("Premium term exceeded 3 characters");
        } else setProdMultiplierPremiumTermError("");

        setProdMultiplierPremiumTerm(e.target.value);
        productRecommendation.prodMultiplierPremiumTerm = e.target.value;
        //actionType = "UPDATE_RIDER_PREMIUM_TERM";
      }

      if (id === "prodMultiplierPolicyTerm" && reNumbers.test(e.target.value)) {
        if (e.target.value.length === 0) {
          setProdMultiplierPolicyTermError("Product policy term is required.");
        } else if (e.target.value.length > 3) {
          setProdMultiplierPolicyTermError("Product policy term exceeded 3 characters");
        } else setProdMultiplierPolicyTermError("");

        setProdMultiplierPolicyTerm(e.target.value);
        productRecommendation.prodMultiplierPolicyTerm = e.target.value;
        //actionType = "UPDATE_RIDER_PREMIUM_TERM";
      }
    }
  }

  /**==================================================
   * VALIDATION - ENSURE MANDATORY FIELDS ARE POPULATED
   ==================================================*/
  function validate() {
    if (addProductMultiplier === true) {
      if (policyIllustration.length <= 0) return false;
      if (prodMultiplierSumAssuredType.length <= 0) return false;
      if (prodMultiplierSumAssured.length <= 0) return false;
      if (prodMultiplierPremium.length <= 0) return false;
      if (prodMultiplierPremiumTerm.length <= 0) return false;
      if (prodMultiplierPolicyTerm.length <= 0) return false;
    }

    return true;
  }

  function clearScreen() {
    setAddProductMultiplier(false);
    setPolicyIllustration("");
    setProdMultiplierSumAssuredType("");
    setProdMultiplierSumAssured("");
    setProdMultiplierPremium("");
    setProdMultiplierPremiumTerm("");
    setProdMultiplierPolicyTerm("");
  }

  return (
    <>
      <Grid size={12}>
        <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
          {title}
        </Typography>
      </Grid>

      <GridCheckbox
        id="addProductMultiplier"
        columnSize="12"
        label="Add Multiplier."
        value="addProductMultiplier"
        disabled={false}
        onChange={handleChange}
        checked={addProductMultiplier}
      />

      {addProductMultiplier && (
        <>
          {/* PER POLICY IOLLUSTRATION */}
          <GridDropdown
            id="policyIllustration"
            key="policyIllustration"
            columnSize="5"
            label="Policy Illustration"
            currState={policyIllustration}
            onChange={handleChange}
            data={policyIllustrationdata}
          />

          {/* MULTIPLIER BENEFIT TYPE*/}
          <GridDropdown
            id="prodMultiplierSumAssuredType"
            key="prodMultiplierSumAssuredType"
            columnSize="2"
            label="Type"
            currState={prodMultiplierSumAssuredType}
            onChange={handleChange}
            data={typeData}
          />

          {/* MULTIPLIER BENEFIT*/}
          <GridTextfield
            id="prodMultiplierSumAssured"
            key="prodMultiplierSumAssured"
            columnSize="5"
            label="Sum Assured"
            currState={prodMultiplierSumAssured}
            onChange={handleChange}
          />

          {/* MULTIPLIER PREMIUM */}
          <GridTextfield
            id="prodMultiplierPremium"
            key="prodMultiplierPremium"
            columnSize="6"
            label="Premium"
            currState={prodMultiplierPremium}
            onChange={handleChange}
          />

          {/* MULTIPLIER PREMIUM TERM */}
          <GridTextfield
            id="prodMultiplierPremiumTerm"
            key="prodMultiplierPremiumTerm"
            columnSize="6"
            label="Premium Term"
            currState={prodMultiplierPremiumTerm}
            onChange={handleChange}
            error={prodMultiplierPremiumTermError}
            helperText={prodMultiplierPremiumTermError}
          />

          {/* MULTIPLIER PREMIUM TERM */}
          <GridTextfield
            id="prodMultiplierPolicyTerm"
            key="prodMultiplierPolicyTerm"
            columnSize="6"
            label="Policy Term"
            currState={prodMultiplierPolicyTerm}
            onChange={handleChange}
            error={prodMultiplierPolicyTermError}
            helperText={prodMultiplierPolicyTermError}
          />
        </>
      )}
    </>
  );
}
